import { makeStyles } from '@mui/styles';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

const useStyles = makeStyles({
  entityTextContainer: {
    marginRight: 55,
    margin: 5,
    display: 'flex',
    alignItems: 'start',
  },
  entityTextTitleContainer: {
    marginRight: 10,
  },
  entityTextTitle: {
    fontFamily: 'Proxima Nova',
    fontSize: 14,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    color: 'var(--black)',
  },
});

const EntityHeaderColumn = ({ firstRowTitle, secondRowTitle, firstRowValue, secondRowValue }) => {
  const classes = useStyles();

  return (
    <div className={classes.entityTextContainer}>
      <div className={classes.entityTextTitleContainer}>
        <Typography className={classes.entityTextTitle}>{firstRowTitle}</Typography>
        <Typography className={classes.entityTextTitle}>{secondRowTitle}</Typography>
      </div>
      <div>
        <Typography className={classes.entityTextTitle}>{firstRowValue}</Typography>
        <Typography className={classes.entityTextTitle}>{secondRowValue}</Typography>
      </div>
    </div>
  );
};

export default EntityHeaderColumn;
